import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import { Box, CardMedia } from '@mui/material';

/**
 * 16:9 placeholder when the project has no thumbnail URL yet.
 */
export function ProjectCardMediaPlaceholder() {
  return (
    <CardMedia
      component="div"
      sx={{
        aspectRatio: '16/9',
        bgcolor: 'grey.100',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1,
          color: 'grey.400',
        }}
      >
        <VideocamOffIcon sx={{ fontSize: 64 }} />
      </Box>
    </CardMedia>
  );
}
